import { useContext } from "react";
import BlogCardHorizontal from "../../cards/BlogCards/BlogCardHorizontal";
import BlogCardVertical from "../../cards/BlogCards/BlogCardVertical";
import { LangContext } from "../../../App";

type SingleBlogType = {
    title : string;
    shortDescription : string;
    image : {
        name : string;
        alt : string;
    }
}

type BlogSectionPropsType = {
    title? : string;
    sectionIndex : number;
    page : string;
    articles : SingleBlogType[];
}

const BlogSection = ({ title, sectionIndex, articles, page } : BlogSectionPropsType) => {
    const { lang } = useContext(LangContext);

    const newArray = articles;
  return (
    <div className="blog-section">
        {
        title ?
        <div className="section-header">
            <h2 className="section-title">{title}</h2>
            {/* {
            lang ?
            <span className="section-number">{newArray.length} مقالة</span> :
            <span className="section-number">{newArray.length} articles</span>
            } */}
        </div> :
        ""
        }
        <div className="section-body">
            {
            newArray.length > 1 ?
            <div className="section-row">
                {
                newArray.map((item, index) => (
                    <div className="section-col" key={index}>
                        <BlogCardVertical 
                            page={page}
                            articleIndex={index}
                            title={item.title}
                            description={item.shortDescription}
                            sectionIndex={sectionIndex}
                            image={{
                                src : require(`../../../assets/images/${page}/${item.image.name}`),
                                alt : item.image.alt
                            }}
                        />
                    </div>
                ))
                }
            </div> :
            <BlogCardHorizontal 
                page={page}
                title={newArray[0].title}
                description={newArray[0].shortDescription}
                sectionIndex={sectionIndex}
                image={{
                    src : require(`../../../assets/images/${page}/${newArray[0].image.name}`),
                    alt : newArray[0].image.alt,
                }}
            />
            }
        </div>
    </div>
  )
}

export default BlogSection